import Cookies from 'js-cookie'
import Modal from './Modal'
import preloaderControl from './modules/preloaderControl'
import './jquery.matchHeight-min'
;('use strict') // Komunikat, wyświetlający się dla starszych przeglądarek
if (navigator.userAgent.match(/(MSIE 10|MSIE 9|MSIE 8|MSIE 7|MSIE 6)/)) {
  // Nawiązanie połączenia
  var makeRequest = function makeRequest(url, cb) {
    xhr = false

    if (window.XMLHttpRequest) {
      xhr = new XMLHttpRequest()

      if (xhr.overrideMimeType) {
        xhr.overrideMimeType('text/xml')
      }
    } else if (window.ActiveXObject) {
      try {
        xhr = new ActiveXObject('Msxml2.XMLHTTP')
      } catch (e) {
        try {
          xhr = new ActiveXObject('Microsoft.XMLHTTP')
        } catch (e) {}
      }
    }

    if (!xhr) {
      alert(oldBrowserModalMessage)
      return false
    }

    xhr.onreadystatechange = function() {
      cb(xhr)
    }

    xhr.open('GET', url, true)
    xhr.send(null)
  } // Callback dla poprawnego pobrania komunikatu

  var loadOldBrowserModal = function loadOldBrowserModal(xhr) {
    if (xhr.readyState == 4) {
      if (xhr.status == 200) {
        var container = document.createElement('div')
        container.className = 'oldBrowserModal'
        container.getAttribute('id', 'oldBrowserModal')
        container.innerHTML = xhr.responseText
        document.getElementById('content').appendChild(container)
        document.getElementById('closeOldBrowserModal').addEventListener('click', function() {
          var modal = document.getElementById('oldBrowserModal')
          modal.parentNode.removeChild(modal)
        })
      } else {
        alert(oldBrowserModalMessage)
      }
    }
  }

  var oldBrowserModalMessage = null
  var oldBrowserModalLink = null

  if (lang) {
    oldBrowserModalLink = 'en/modules/oldBrowserModal.php'
    oldBrowserModalMessage =
      "It looks like you're using an outdated browser and our site may not work properly. Please update it or use another one."
  } else {
    oldBrowserModalLink = 'modules/oldBrowserModal.php'
    oldBrowserModalMessage =
      'Wygląda na to, używasz przestarzałej przeglądarki i przez to nasza strona może działać niepoprawnie. Prosimy o jej zaaktualizowanie, lub o skorzystanie z innej.'
  }

  var xhr = null
  makeRequest($root + oldBrowserModalLink, loadOldBrowserModal)
} //Wykrywamy zjebaną przeglądarkę ie

function detectIE() {
  var ua = window.navigator.userAgent // Test values; Uncomment to check result …
  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ')

  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
  }

  var trident = ua.indexOf('Trident/')

  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:')
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }

  var edge = ua.indexOf('Edge/')

  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
  } // other browser

  return false
}

var ie = 0 // Get IE or Edge browser version

var version = detectIE()

if (version === false) {
  // nie ie
} else if (version >= 12) {
  // nie ie, chyba edge :)
  ie = 0
} else {
  // ie
  ie = 1
}

if (ie) {
  $('.progressBarWrap, .modalContent .progress, #seeOnLine, .kontaktTable, #ourAdvantages .preloader').addClass('explorer')
}

if (window.location.hash === '#szybka-wycena') {
  $(document).ready(function() {
    $('#wycenaLink').trigger('click')
  })
} //faq

if ($('#faq').length) {
  var faq = new faqTabs('#faq')
} // Initializacja tooltipów

if (jQuery().tooltip) {
  var tooltips = jQuery('[data-toggle="tooltip"]')
  tooltips.tooltip()
  tooltips.on('click', function(e) {
    e.preventDefault()
  })
}

function preloader() {
  window.addEventListener('load', function() {
    var container = $('#preloader')
    container.fadeOut()
  })
}

preloader()

$('.footOffer').click(function() {
  $(this)
    .siblings('ul')
    .slideToggle()
}) //match height

if ($('.leadingBlogItem').length != 0) {
  $('.leadingBlogItem, .sidebar').matchHeight({
    property: 'min-height'
  })
}

if ($('.standardBlogItem').length > 0) {
  $('.standardBlogItem').matchHeight({
    property: 'height',
    byRow: false
  })
}

if ($('#ofertaSkrocona .ofertaItem p').length > 0) {
  $('#ofertaSkrocona .ofertaItem p').matchHeight()
} // slider z suwakiem w sekcji oferta

$('.toggle').click(function() {
  $(this).toggleClass('clicked')
  $('.mobileMenuWrap').toggleClass('showMenu')
  $('body').toggleClass('overflowed')
  $('.mobileLogoBelt--fixed').toggleClass('white-bg')
  $('.mobileMenu.mobile').toggleClass('active')
})
$('.mobileMenuWrap .menuParent.label').click(function() {
  $(this)
    .find('i')
    .toggleClass('rotated-i')
  $(this)
    .find('ul')
    .slideToggle()
}) // hover menu

$('.normalMenu ul.mainMenu > .menuParent').hover(
  function() {
    $('.menuBg').addClass('hoverBg')
  },
  function() {
    $('.menuBg').removeClass('hoverBg')
  }
) // przycisk wyślij brief w menu

$('.brief').click(function(e) {
  e.preventDefault()
  $('#wycenaLink').trigger('click')
  setTimeout(function() {
    var modal = document.querySelectorAll('#wycenaModal .whiteBg')

    if (modal.length > 1) {
      modal[1].parentNode.removeChild(modal[1])
    }
  }, 1500)
}) // scrollowanie po kliknięciu do określonego elementu.

var preloder = function preloder(element) {
  var thi$ = this
  thi$.element = $(element)

  thi$.prepare = function() {
    thi$.element.css('opacity', 0)
  }

  thi$.preloadMechanism = function() {
    $('.preloader').animate(
      {
        opacity: 0
      },
      300,
      function() {
        $('.preloaderWrap').remove()
      }
    )
    thi$.element.delay(300).animate(
      {
        opacity: 1
      },
      1000
    )
  }

  if (thi$.element.length > 0) {
    thi$.prepare()
    $(window).on('load', function() {
      thi$.preloadMechanism()
    })
  }
}

var laduj = new preloder('body.case-study .portfolioWrap .portfolioGrid') //preloader w formularzach

/*
  var horizontalPosition = 0;
  $( '.imagesContainer' ).on( "mousemove",  function(event) {
    horizontalPosition = event.pageX / 10;
  horizontalPosition = horizontalPosition -80;
    $(this).css('left','-'+horizontalPosition+'px');
  });

  */

if ($('.aboutImage').length > 0) {
  $('.aboutImage')
    .not('.case-next-project .aboutImage')
    .draggable({
      //refreshPositions: true
    }) //   $( ".aboutImage" ).resizable();
} // mapa

if ($('#map').length > 0) {
  var initMap = function initMap() {
    var mapOptions = {
      scrollwheel: false,
      mapTypeControl: false,
      zoom: 15,
      center: new google.maps.LatLng(52.4066913,16.919618),
      styles: [
        {
          featureType: 'all',
          elementType: 'labels.text.fill',
          stylers: [
            {
              saturation: 36
            },
            {
              color: '#000000'
            },
            {
              lightness: 40
            }
          ]
        },
        {
          featureType: 'all',
          elementType: 'labels.text.stroke',
          stylers: [
            {
              visibility: 'on'
            },
            {
              color: '#000000'
            },
            {
              lightness: 16
            }
          ]
        },
        {
          featureType: 'all',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#000000'
            },
            {
              lightness: 20
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#000000'
            },
            {
              lightness: 17
            },
            {
              weight: 1.2
            }
          ]
        },
        {
          featureType: 'administrative',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'administrative.country',
          elementType: 'all',
          stylers: [
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'administrative.country',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'administrative.country',
          elementType: 'labels.text',
          stylers: [
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'administrative.province',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'administrative.locality',
          elementType: 'all',
          stylers: [
            {
              visibility: 'simplified'
            },
            {
              saturation: '-100'
            },
            {
              lightness: '30'
            }
          ]
        },
        {
          featureType: 'administrative.neighborhood',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'landscape',
          elementType: 'all',
          stylers: [
            {
              visibility: 'simplified'
            },
            {
              gamma: '0.00'
            },
            {
              lightness: '74'
            }
          ]
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [
            {
              color: '#000000'
            },
            {
              lightness: 20
            }
          ]
        },
        {
          featureType: 'landscape.man_made',
          elementType: 'all',
          stylers: [
            {
              lightness: '3'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#000000'
            },
            {
              lightness: 21
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'simplified'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#000000'
            },
            {
              lightness: 17
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#000000'
            },
            {
              lightness: 29
            },
            {
              weight: 0.2
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [
            {
              color: '#000000'
            },
            {
              lightness: 18
            }
          ]
        },
        {
          featureType: 'road.local',
          elementType: 'geometry',
          stylers: [
            {
              color: '#000000'
            },
            {
              lightness: 16
            }
          ]
        },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [
            {
              color: '#000000'
            },
            {
              lightness: 19
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#000000'
            },
            {
              lightness: 17
            }
          ]
        }
      ]
    }
    var mapElement = document.getElementById('map')
    var map = new google.maps.Map(mapElement, mapOptions)
    var markerImage = new google.maps.MarkerImage(
      $root + 'images/kontakt/pin.png',
      new google.maps.Size(70, 70),
      new google.maps.Point(0, 0),
      new google.maps.Point(35, 35)
    )
    var marker = new google.maps.Marker({
      position: new google.maps.LatLng(52.4066913, 16.919618),
      map: map,
      icon: markerImage,
      title: 'Empressia'
    })
  }

  google.maps.event.addDomListener(window, 'load', initMap)
} //   formularz kontaktowy w kontakcie, obsługa wysyłania

var contactPreloader = new preloaderControl('#contactForm')
var contactForm = $('.kontaktForm form')
contactForm.submit(function(e) {
  e.preventDefault()
  var proceed = true //simple validation at client's end
  $('#contactForm button[type="submit"]').attr('disabled', true);
  //loop through each field and we simply change border color to red for invalid fields

  $('#contactForm  input[required], #contactForm textarea[required]').each(function() {
    $(this).css('border-color', 'rgba(85,97,136,0.2)')

    if (!$.trim($(this).val())) {
      //if this field is empty
      $(this).css('border-color', 'red') //change border color to red

      proceed = false //set do not proceed flag

      if (lang) {
        $('#form-messages').html('<div class="error">Fill all required fields</div>')
      } else {
        $('#form-messages').html('<div class="error">Wypełnij poprawnie wymagane pola</div>')
      }
    } //check invalid email

    var email_reg = /^([\w-\.]+@([\w-]+\.)+[\w-]+)?$/

    if ($(this).attr('type') == 'email' && !email_reg.test($.trim($(this).val()))) {
      $(this).css('border-color', 'red') //change border color to red

      proceed = false //set do not proceed flag

      if (lang) {
        $('#form-messages').html('<div class="error">Fill all required fields</div>')
      } else {
        $('#form-messages').html('<div class="error">Wypełnij poprawnie wymagane pola</div>')
      }
    }
  }) // walidacja checkobxa ze zgodą

  var agree = 'nie'
  var isError = false

  if ($('#agreement2').is(':checked')) {
    var parent = $(this).parent()
    agree = 'tak'
    parent.find('.checkboxField').css({
      border: '',
      opacity: ''
    })
    parent.find('label').css('color', '')
  } else {
    proceed = false
    var parent = $(this).parent()
    parent.find('.checkboxField').css({
      border: '2px solid red',
      opacity: '1'
    })
    parent.find('label').css('color', 'red')
  }

  grecaptcha.ready(function() {
    grecaptcha
      .execute('6LeHz5wUAAAAAAlJGXRx72rnrtezw3rU0f-A8wrD', {
        action: 'homepage'
      })
      .then(function(token) {
        if (proceed) {
          //everything looks good! proceed...
          contactPreloader.showPreloader() //get input field values data to be sent to server

          var parent = $('.kontaktForm .col-md-12')
          var post_data = {
            'Klient z adwords': $('.kontaktForm form input#adwords_info').val(),
            name: $('.kontaktForm form input[name=name]').val(),
            email: $('.kontaktForm form input[name=email]').val(),
            telefon: $('.kontaktForm form input[name=phone]').val(),
            treść: $('.kontaktForm form textarea[name=tresc]').val(),
            agreement: agree,
            'token-captcha': token
          }

          if (post_data['Klient z adwords'] == 0) {
            delete post_data['Klient z adwords']
          } else {
            post_data['Klient z adwords'] = 'tak'
          } //Ajax post data to server

          $.ajax({
            method: 'POST',
            url: $root + 'php/contact_mail.php',
            // działa tylko jeśli adres url prowadzi ze strony głownej, poprawić  !!
            data: 'data=' + JSON.stringify(post_data)
          })
            .done(function(msg) {
              console.dir(msg) // pokazujemy info czy wysyłka się udała, usuwamy preloader i wyłączamy formularz żeby jakiś nie w pełni sprytny koleś nie wysłał maila 15 razy :).

              msg = JSON.parse(msg)

              if (msg.error) {
                if (lang) {
                  parent.html(
                    '<div class="resultMessage"><img src="' +
                      $root +
                      'images/error.svg"><p>server connection fail :(<br> try again later</p></div>'
                  )
                } else {
                  parent.html(
                    '<div class="resultMessage"><img src="' +
                      $root +
                      'images/error.svg"><p>Niestety nie udało się połączyć z&nbsp;serwerem :(<br>spróbuj ponownie za&nbsp;jakiś czas</p></div>'
                  )
                }

                console.log('błąd po stronie serwera: ' + msg.error)
                isError = true
              } else if (msg.success) {
                if (lang) {
                  parent.html(
                    '<div class="resultMessage"><img src="' +
                      $root +
                      'images/success.svg"><h4>Thanks</h4><p>Your email has been sent, we will try to answer as soon as posible.</p></div>'
                  )
                } else {
                  parent.html(
                    '<div class="resultMessage"><img src="' +
                      $root +
                      'images/success.svg"><h4>Dziękujemy</h4><p>Twoja wiadomość została wysłana, postaramy się odpowiedzieć najszybciej jak to możliwe.</p></div>'
                  )
                }

                isError = true //informacja dla google manager TAG

                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'formKontakt'
                })
              }

              contactPreloader.removePreloader();
              // $('#contactForm button[type="submit"]').attr('disabled', false);
            })
            .fail(function() {
              // błąd w połączeniu z plikiem php
              if (lang) {
                parent.html(
                  '<div class="resultMessage"><img src="' +
                    $root +
                    'images/error.svg"><p>server connection fail :(<br> try again later</p></div>'
                )
              } else {
                parent.html(
                  '<div class="resultMessage"><img src="' +
                    $root +
                    'images/error.svg"><p>Niestety nie udało się połączyć z&nbsp;serwerem :(<br>spróbuj ponownie za&nbsp;jakiś czas</p></div>'
                )
              }

              isError = true
              contactPreloader.removePreloader();
              $('#contactForm button[type="submit"]').attr('disabled', false);
            })
        }
      })
  })

  if (isError) {
    var vaniliaContactForm = contactForm[0]
    var subject = 'Zapytanie ze strony empressia.pl'
    var formData = new FormData(vaniliaContactForm)
    var name = formData.get('name')
    var email = formData.get('email')
    var phone = formData.get('phone')
    var message = formData.get('tresc').replace(/\n/g, '<br>\n')
    var body = '\n      '
      .concat(name, '<br>\n      ')
      .concat(phone, '<br><br>\n      ')
      .concat(message, '<br><br>\n    ')
    window.location.href = 'mailto:'
      .concat(email, '?subject=')
      .concat(subject, '&body=')
      .concat(body)
  }
}) //reset previously set border colors and hide all message on .keyup()

$('.kontaktForm form   input[required=true], .kontaktForm form  textarea[required=true]').keyup(function() {
  $(this).css('border-color', '')
  $('#form-messages').slideUp()
})
var modalWycenaLoaded = false
var wycenaModalLangPath = null
wycenaModalLangPath = $root + 'modules/wycena-modal/dist/index.html'
$('#wycenaLink').click(function(e) {
  e.preventDefault()

  if (!modalWycenaLoaded) {
    showNewModal()
    modalWycenaLoaded = true
    $('#wycenaModalContainer').load(wycenaModalLangPath, function() {
      $.getScript($root + 'js/ion.rangeSlider.min.js', function() {
        $.getScript($root + 'js/wycenaModalScripts.js', function() {
          $('#wycenaModal .preloaderModalWrap').fadeOut(300)
          $('#wycenaModalContainer').fadeIn(300)
          var href = window.location.href
          var state = href.replace(/(.*)\/(.*)((\?|#).*)$/g, '$2')
          window.history.pushState(
            {
              page: state
            },
            state,
            state
          )

          window.onpopstate = function(event) {
            $('.closeModal').trigger('click')
          }
        })
      })
    })
  } else {
    showNewModal()
  }
})

function showWycenaModal() {
  var wycenaModal = $('#wycenaModal')
  wycenaModal.addClass('showModal animateModal')
  wycenaModal.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
    wycenaModal.removeClass('animateModal')
    $('body').addClass('overflowed')

    if ($(window).width() > 992) {
      $('.modalContent').addClass('scrollBarFix')
    }
  })
  $('#wycenaModal .progress').height(0)
}

function showNewModal() {
  var wycenaModal = $('#wycenaModal')
  var wycenaModalLangPath = $root + 'modules/wycena-modal/dist/index.html'
  wycenaModal.addClass('showModal animateModal')
  wycenaModal.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
    wycenaModal.removeClass('animateModal')
    $('body').addClass('overflowed')

    if ($(window).width() > 992) {
      $('.modalContent').addClass('scrollBarFix')
    }
  })
  $('#wycenaModal .progress').height(0)
  $('#wycenaModalContainer').load(wycenaModalLangPath, function() {
    $.getScript($root + 'js/ion.rangeSlider.min.js', function() {
      $.getScript($root + 'js/wycenaModalScripts.js', function() {
        $('#wycenaModal .preloaderModalWrap').fadeOut(300)
        $('#wycenaModalContainer').fadeIn(300)
        var href = window.location.href
        var state = href.replace(/(.*)\/(.*)((\?|#).*)$/g, '$2')
        window.history.pushState(
          {
            page: state
          },
          state,
          state
        )

        window.onpopstate = function(event) {
          $('.closeModal').trigger('click')
        }
      })
    })
  })
} // portfiolio masnory

window.checkForMobileDevices = function() {
  var check = false

  ;(function(a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true
  })(navigator.userAgent || navigator.vendor || window.opera)

  return check
} //  portfolio modal

var showFolio = function showFolio() {
  var thi$ = this
  thi$.actualSite = ''

  thi$.clickMagic = function() {
    $('.portfolioGrid div:not(.caseStudy) .gridItem').click(function(e) {
      if (($(window).width() > 992 || !window.checkForMobileDevices()) && !ie) {
        // sprawdzamy czy to nie są mobilki lub internet explorer jesli jest to nie wączamy modala tylko stronę statyczną
        e.preventDefault()
        var targetElement = $('#portfolioModal')
        var href = $(this).attr('href')
        var file = href.replace(/(^.*)\/(.*)$/g, '$2')

        if (lang) {
          var filePath = $root + 'en/portfolio/' + file + '.php?root=' + $root
        } else {
          var filePath = $root + 'case-study/' + file + '.php?root=' + $root
        }

        targetElement.show()
        $('.portfolioModalWrap').load(filePath, function() {
          thi$.actualSite = href
          thi$.closeFolio()
          thi$.navigationControl()
          thi$.historyControl()
          var preloader = new preloaderControl('.portfolioCols.fatColl')
          preloader.showPreloader()
          preloader.changeStyles({
            'z-index': '95'
          })
        })
        targetElement.addClass(' animateModal')
        targetElement.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
          targetElement.removeClass('animateModal')
          $('body').addClass('overflowed')

          if ($(window).width() > 992) {
            $('.portfolioModalWrap').addClass('scrollBarFix')
          }
        })
      }
    })
  }

  thi$.closeFolio = function() {
    $('a.closePortfolio').click(function(e) {
      var targetElement = $('#portfolioModal')
      e.preventDefault()
      $('.toggle').removeClass('clicked')
      $('.mobileMenuWrap').removeClass('showMenu')
      $('body').removeClass('overflowed')
      $('.portfolioModalWrap').removeClass('scrollBarFix')
      targetElement.addClass(' closeModal')
      targetElement.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
        targetElement.removeClass('closeModal')
        targetElement.hide()
      })
    })
  }

  thi$.navigationControl = function() {
    var actualSiteName = thi$.actualSite.replace(/(.*)\/(.*\/?)$/g, '$2')
    var before = ''
    var after = ''
    var wylacznik = 0 // szukamy poprzedni i następny obiekt  w tablicy z portfolio

    for (const item in portfolioJson) {
      if (portfolioJson[item].type.indexOf('caseStudy') >= 0) {
        continue
      }

      after = item

      if (wylacznik == 1) {
        break
      }

      if (item == actualSiteName) {
        wylacznik = 1
      }

      if (item != actualSiteName) {
        before = item
      }
    } //  blokujemy strzałki w nawigacji jeśli aktualnie włączony jest ostatni lub pierwszy element

    if (after == actualSiteName) {
      $('.portfolioNext').addClass('locked')
    }

    if (before == '') {
      $('.portfolioPrev').addClass('locked')
    }

    $('.portfolioNavs').click(function(e) {
      e.preventDefault()

      if ($(this).hasClass('portfolioNext')) {
        var href = after //  var href = $('.portfolioGrid .portfolioGridItem a[href="'+thi$.actualSite+'"]').parent('.portfolioGridItem').next('.portfolioGridItem').find('a').attr('href');
      } else if ($(this).hasClass('portfolioPrev')) {
        var href = before //var href = $('.portfolioGrid .portfolioGridItem a[href="'+thi$.actualSite+'"]').parent('.portfolioGridItem').prev('.portfolioGridItem').find('a').attr('href');
      }

      if (href && !$(this).hasClass('locked')) {
        var file = href
        $('.portfolioNavs').addClass('locked')
        $('<div class="portfolioModalWrap nextWrap" > </div>').insertAfter('.portfolioModalWrap') //  $('#portfolioModal').append('<div class="portfolioModalWrap nextWrap" > </div>')

        if (lang) {
          var filePath = $root + 'en/portfolio/' + file + '.php?root=' + $root
        } else {
          var filePath = $root + 'case-study/' + file + '.php?root=' + $root
        }

        $('.nextWrap').load(filePath, function() {
          thi$.actualSite = href
          thi$.closeFolio()
          thi$.navigationControl()
          var preloader = new preloaderControl('.portfolioCols.fatColl')
          preloader.showPreloader()
          preloader.changeStyles({
            'z-index': '95'
          })
          $('.portfolioModalWrap:not(.nextWrap)').animate(
            {
              opacity: '0'
            },
            700,
            function() {
              $('.portfolioModalWrap:not(.nextWrap)').remove()
              $('.nextWrap').removeClass('nextWrap')
            }
          )
        })
      }
    })
  }

  thi$.historyControl = function() {
    var href = window.location.href
    var state = href.replace(/(.*)\/(.*)((\?|#).*)$/g, '$2')
    window.history.pushState(
      {
        page: state
      },
      state,
      state
    )

    window.onpopstate = function(event) {
      $('a.closePortfolio').trigger('click')
    }
  }

  thi$.clickMagic()
}

var portfolioDzialaj = new showFolio() //  ogłoszenia o pracę modal

var jobOffer = function jobOffer() {
  var thi$ = this
  thi$.actualSite = ''

  thi$.clickMagic = function() {
    $('.workLink').click(function(e) {
      if (($(window).width() > 992 || !window.checkForMobileDevices()) && !ie) {
        // sprawdzamy czy to nie są mobilki lub internet explorer jesli jest to nie wączamy modala tylko stronę statyczną
        e.preventDefault()
        var targetElement = $('#workModal')
        var href = $(this).attr('href')
        var file = href.replace(/(^.*)\/(.*)$/g, '$2')
        targetElement.show()
        $('.workModalWrap').load('work/' + file + '.php', function() {
          thi$.actualSite = href
          thi$.closeFolio()
          thi$.navigationControl()
          thi$.historyControl()
        })
        targetElement.addClass(' animateModal')
        targetElement.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
          targetElement.removeClass('animateModal')
          $('body').addClass('overflowed')

          if ($(window).width() > 992) {
            $('.workModalWrap').addClass('scrollBarFix')
          }
        })
      }
    })
  }

  thi$.closeFolio = function() {
    $('a.closePortfolio').click(function(e) {
      var targetElement = $('#workModal')
      e.preventDefault()
      $('.toggle').removeClass('clicked')
      $('.mobileMenuWrap').removeClass('showMenu')
      $('body').removeClass('overflowed')
      $('.workModalWrap').removeClass('scrollBarFix')
      targetElement.addClass(' closeModal')
      targetElement.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
        targetElement.removeClass('closeModal')
        targetElement.hide()
      })
    })
  }

  thi$.navigationControl = function() {
    var actualSiteName = thi$.actualSite.replace(/(.*)\/(.*\/?)$/g, '$2')
    var before = ''
    var after = ''
    var wylacznik = 0 // szukamy poprzedni i następny obiekt  w tablicy z ofertami

    for (const item in workJson) {
      after = item

      if (wylacznik == 1) {
        break
      }

      if (item == actualSiteName) {
        wylacznik = 1
      }

      if (item != actualSiteName) {
        before = item
      }
    } //  blokujemy strzałki w nawigacji jeśli aktualnie włączony jest ostatni lub pierwszy element

    if (after == actualSiteName) {
      $('.portfolioNext').addClass('locked')
    }

    if (before == '') {
      $('.portfolioPrev').addClass('locked')
    }

    $('.portfolioNavs').click(function(e) {
      e.preventDefault()

      if ($(this).hasClass('portfolioNext')) {
        var href = after //  var href = $('.portfolioGrid .portfolioGridItem a[href="'+thi$.actualSite+'"]').parent('.portfolioGridItem').next('.portfolioGridItem').find('a').attr('href');
      } else if ($(this).hasClass('portfolioPrev')) {
        var href = before //var href = $('.portfolioGrid .portfolioGridItem a[href="'+thi$.actualSite+'"]').parent('.portfolioGridItem').prev('.portfolioGridItem').find('a').attr('href');
      }

      if (href && !$(this).hasClass('locked')) {
        var file = href
        $('.portfolioNavs').addClass('locked')
        $('<div class="workModalWrap nextWrap" > </div>').insertAfter('.workModalWrap')
        $('.nextWrap').load('work/' + file + '.php', function() {
          thi$.actualSite = href
          thi$.closeFolio()
          thi$.navigationControl()
          $('.workModalWrap:not(.nextWrap)').animate(
            {
              opacity: '0'
            },
            700,
            function() {
              $('.workModalWrap:not(.nextWrap)').remove()
              $('.nextWrap').removeClass('nextWrap')
            }
          )
        })
      }
    })
  }

  thi$.historyControl = function() {
    var href = window.location.href
    var state = href.replace(/(.*)\/(.*)((\?|#).*)$/g, '$2')
    window.history.pushState(
      {
        page: state
      },
      state,
      state
    )

    window.onpopstate = function(event) {
      $('a.closePortfolio').trigger('click')
    }
  }

  thi$.clickMagic()
}

var work = new jobOffer() /// tabela z wyceną w wersji mobilnej

var mobileTable = function mobileTable() {
  var trigger = 1

  if ($(this).width() < 993 && trigger == 1) {
    var titles = []
    $('.priceTable.computer td.titleCol').each(function() {
      titles.push($(this).html())
    })
    $('.priceTable.start tbody').remove()
    $('.priceTable.start tr').remove()
    var counter = 0
    $('.priceTable.computer td:nth-child(2)').each(function() {
      var content = $(this).html()
      $('.priceTable.start').append('<tr><td><p class="titleCol">' + titles[counter] + '</p>' + content + '</td></tr>')
      counter++
    })
    $('.priceTable.standard tbody').remove()
    $('.priceTable.standard tr').remove()
    counter = 0
    $('.priceTable.computer td:nth-child(3)').each(function() {
      var content = $(this).html()
      $('.priceTable.standard').append('<tr><td><p class="titleCol">' + titles[counter] + '</p>' + content + '</td></tr>')
      counter++
    })
    $('.priceTable.optimal tbody').remove()
    $('.priceTable.optimal tr').remove()
    counter = 0
    $('.priceTable.computer td:nth-child(4)').each(function() {
      var content = $(this).html()
      $('.priceTable.optimal').append('<tr><td><p class="titleCol">' + titles[counter] + '</p>' + content + '</td></tr>')
      counter++
    })
    $('.priceTable.premium tbody').remove()
    $('.priceTable.premium tr').remove()
    counter = 0
    $('.priceTable.computer td:nth-child(5)').each(function() {
      var content = $(this).html()
      $('.priceTable.premium').append('<tr><td><p class="titleCol">' + titles[counter] + '</p>' + content + '</td></tr>')
      counter++
    })
    $('.priceTable.custom tbody').remove()
    $('.priceTable.custom tr').remove()
    var counter = 0
    $('.priceTable.computer td:nth-child(6)').each(function() {
      var content = $(this).html()
      $('.priceTable.custom').append('<tr><td><p class="titleCol">' + titles[counter] + '</p>' + content + '</td></tr>')
      counter++
    })
    trigger = 0
  } else if ($(this).width() > 992 && trigger == 0) {
    trigger = 1
  }
}

mobileTable()
$(window).resize(function() {
  mobileTable()
}) // animacja w kim jesteśmy

var whoWeAre = function whoWeAre() {
  var t = this

  t.scrolMechanism = function() {
    var distance = $('#ourAdvantages').offset().top
    var height = $('#ourAdvantages').height()
    var offset = 150
    distance = distance - height + offset

    if ($(window).scrollTop() >= distance) {
      $('#ourAdvantages').addClass('run')
      $('.advItem').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
        $(this).addClass('fly')
      })
    }
  }

  $(window).scroll(function() {
    t.scrolMechanism()
  })
}

if ($('#ourAdvantages').length > 0) {
  var whoWeAreAnimation = new whoWeAre()
}

var preloaderTemplate = '<div class="preloaderWrap jQueryPreloader">'
preloaderTemplate += '<div class="preloader">'
preloaderTemplate += '<span></span>'
preloaderTemplate += '<span></span>'
preloaderTemplate += '<span></span>'
preloaderTemplate += ' <span></span>'
preloaderTemplate += ' </div></div>'
/*
  if ($('.blog .blogItem').length > 0) {

      var lazyLoadDownload = new lazySnail('.blogItem ', {
          itemStartCount: 7,
          type: 'onScroll',
          scrollOffset: 100,
          moreLink: preloaderTemplate,
          numberOfRevealedItems: 6,
          method: 'background-image'
      });
  }
*/
// animowany svg w menu

$('.mainMenu [data-ico]').hover(function() {
  $('.mainMenu .menuIco').hide()
  var target = $(this).data('ico')

  if (ie) {
    $('.mainMenu .' + target + 'jpg').show()
  } else {
    $('.mainMenu #' + target).show()
  }
}) //pokazujące się elementy przy skrolowaniu w case-study

function apearElementsController() {
  var t = this
  t.offset = 100 // odległość od dolnej krawędzi przeglądarki, regulacja pojawiania się elementów

  t.checkElements = function() {
    $('.animateMe').each(function() {
      var apearOffset = 0
      apearOffset = $(this).data('apear-offset')

      if (apearOffset == undefined) {
        apearOffset = t.offset
      }

      if ($(this).offset().top < $(window).scrollTop() + $(window).height() - apearOffset) {
        $(this).addClass('showMe')
      }
    })
  }

  t.checkElements()
  $(window).scroll(function() {
    t.checkElements()
  })
}

var apearElementsRun = new apearElementsController() // scrollTop

var scroller = function scroller(element, className, distanceFromTop, mode) {
  if (typeof distanceFromTop !== 'undefined') {
    distanceFromTop = 500
  }

  var t = this
  element = $(element)

  if (mode === 'top') {
    t.clicker = function() {
      element.click(function(e) {
        e.preventDefault()
        $('html, body').animate(
          {
            scrollTop: 0
          },
          1000,
          'swing'
        )
      })
    }

    t.clicker()
  }

  t.showButton = function() {
    $(window).scroll(function() {
      if ($(this).scrollTop() > distanceFromTop) {
        $(element).addClass(className)
      } else {
        $(element).removeClass(className)
      }
    })
  }

  t.showButton()
}

var scrollTop = new scroller('.scrolltop', 'showScroll', 900, 'top')
var mobileBar = new scroller('.mobileBar', 'showed', 900, 'link') //Własny pakiet reklamowy

var customTable = $('.custom-table'),
  customCell = $('.custom-cell'),
  customSelect = $('.custom-cell select'),
  formPlan = null,
  rabatValue = $('.custom-rabat-value'),
  rabatArray = []
customSelect.on('change', function() {
  var $this = this
  customSelect.each(function(i, elem) {
    rabatArray[i] = parseInt(elem.options[elem.selectedIndex].dataset.rabat)
  })
  rabatValue.text(
    rabatArray.reduce(function(prev, next) {
      return prev + next
    }, 0)
  )
}) // modal z referencjami klientów w sekcji co docenili nasi klienci i jednocześnie z formularzem który pokazuje się po kliknięciu na przycisk wybieram na podstronie "marketing", w tabeli z pakietami

var Refmodal = function Refmodal() {
  var modal = new Modal('.referenceModalWrap, .formModal')
  var t = this

  t.clicker = function() {
    $('body').on('click', '#klienci .owlItem .moreLink, .prices  .wybieram-modal', function(e) {
      e.preventDefault()
      var data = $(this).data('reference')
      var alt = $(this).data('alt')
      var referenceImg = $('.referenceModalWrap .reference img')
      referenceImg.attr('src', data)
      referenceImg.attr('alt', alt)
      formPlan = $(this).attr('href')
      var sentence = 'Witam jestem zainteresowany pakietem ' + formPlan + ', proszę o kontakt'
      $('.formModal .modalContactForm textarea').html(sentence)
      modal.start()
    })
  }

  this.clicker()
}

if ($('.referenceModalWrap, .formModal').length) {
  var referenece = new Refmodal()
}

$('.modalContactForm').submit(function(e) {
  e.preventDefault()
  var planPreloader = new preloaderControl('section.prices .reference ')
  planPreloader.showPreloader()
  var parent = $('section.prices .reference form')
  var post_data = {
    name: $('form.modalContactForm  input[name=name]').val(),
    email: $('form.modalContactForm  input[name=email]').val(),
    telefon: $('form.modalContactForm  input[name=phone]').val(),
    treść: $('form.modalContactForm  textarea[name=content]').val()
  }

  if (formPlan === 'Personal') {
    post_data['Własne opcje'] = '----------------------'
    post_data['Pozycjonowanie'] = $('.custom-cell-pozycjonowanie').val() + ' fraz'
    post_data['Mapy Google'] = $('.custom-cell-mapy-google').val()
    post_data['Linki sponsorowane'] = $('.custom-cell-linki-sponsorowane').val() + ' zł / mc'
    post_data['Remarketing'] = $('.custom-cell-remarketing').val()
    post_data['Marketing szeptany'] = $('.custom-cell-marketing-szeptany').val() + ' posty / mc'
    post_data['FB'] = 'po ' + $('.custom-cell-kampania-fb').val() + ' wpisy / mc'
    post_data['Kampania FB'] = 'po ' + $('.custom-cell-socials').val() + ' wpisy / mc'
    post_data['Instalacja wtyczek social'] = $('.custom-cell-wtyczki').val()
    post_data['Statystyki odwiedzin'] = $('.custom-cell-statystyki').val()
    post_data['Aktualizacja strony'] = $('.custom-cell-aktualizacja').val() + ' / mc'
    post_data['Stworzenie www'] = $('.custom-rabat-value').text() + '% Rabatu'
    post_data['Optymalizacja'] = $('.custom-cell-optymalizacja').val()
    post_data['Katalogowanie'] = $('.custom-cell-katalogowanie').val() + ' katalogów / mc'
    post_data['Artykuły sponsorowane'] = $('.custom-cell-sponsorowane').val() + ' / mc'
  } //Ajax post data to server

  $.ajax({
    method: 'POST',
    url: $root + 'php/plan_form.php',
    data: 'data=' + JSON.stringify(post_data)
  })
    .done(function(msg) {
      // pokazujemy info czy wysyłka się udała, usuwamy preloader i wyłączamy formularz żeby jakiś nie w pełni sprytny koleś nie wysłał maila 15 razy :).
      msg = JSON.parse(msg)
      planPreloader.removePreloader()

      if (msg.error) {
        if (lang) {
          parent.html('<div class="resultMessage"><p>Server connection failed :(<br>try again later</p></div>')
        } else {
          parent.html(
            '<div class="resultMessage"><p>Niestety nie udało się połączyć z&nbsp;serwerem :(<br>spróbuj ponownie za&nbsp;jakiś czas</p></div>'
          )
        }

        console.log('błąd po stronie serwera: ' + msg.error)
      } else if (msg.success) {
        if (lang) {
          parent.html(
            '<div class="resultMessage"><h4>Thanks</h4><p>Your email has been sent, we will answer as soon as possible</p></div>'
          )
        } else {
          parent.html(
            '<div class="resultMessage"><h4>Dziękujemy</h4><p>Twoja wiadomość została wysłana, postaramy się odpowiedzieć najszybciej jak to możliwe</p></div>'
          )
        } //informacja dla google manager TAG

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'formPakiet'
        })
      }

      setTimeout(function() {
        $('.prices .closeRef').trigger('click')
      }, 3500)
    })
    .fail(function() {
      // błąd w połączeniu z plikiem php
      planPreloader.removePreloader()

      if (lang) {
        parent.html('<div class="resultMessage"><p>Server connection failed :(<br>try again later</p></div>')
      } else {
        parent.html(
          '<div class="resultMessage"><p>Niestety nie udało się połączyć z&nbsp;serwerem :(<br>spróbuj ponownie za&nbsp;jakiś czas</p></div>'
        )
      }

      setTimeout(function() {
        $('.prices .closeRef').trigger('click')
      }, 3500)
    })
}) // cisateczka info

if (localStorage.cookie != 1) {
  setTimeout(function() {
    $('.cookieInfo').addClass('showCookie')
  }, 4000)
}

setTimeout(function() {
  $('#oldSiteModal').addClass('oldSiteModalStart')
}, 1800)
$('#oldSiteModal a.begin').click(function(e) {
  e.preventDefault()
  $('#oldSiteModal').addClass('oldSiteModalHide')
  $('body').removeClass('overflowed')
}) // ciasteczka w przełącznikach języków

$('.langSwitcher a').click(function(e) {
  e.preventDefault()
  var content = $(this).data('lang')
  var href = $(this).attr('href')
  Cookies.set('languageCookie', content, {
    expires: 15,
    path: '/'
  })
  location.href = href
}) // dodanie informacji przy próbie kopiowania

function getSelectionHtml() {
  var html = ''

  if (typeof window.getSelection != 'undefined') {
    var sel = window.getSelection()

    if (sel.rangeCount) {
      var container = document.createElement('div')

      for (var i = 0, len = sel.rangeCount; i < len; ++i) {
        container.appendChild(sel.getRangeAt(i).cloneContents())
      }

      html = container.innerHTML
    }
  } else if (typeof document.selection != 'undefined') {
    if (document.selection.type == 'Text') {
      html = document.selection.createRange().htmlText
    }
  }

  return html
}

function copySelection() {
  var advert = "[Więcej na <a href='https://www.empressia.pl'>www.empressia.pl</a>]"
  var pagecopy =
    "<span style='font-weight:bold; color:red;'>Treść pochodzi ze strony: <a href='https://www.empressia.pl'>www.empressia.pl</a>. Nasze treści monitorujemy na bieżąco, dlatego nie kopiuj ich bez naszej zgody, ponieważ to prawnie zabronione.</span>"
  var copytext = getSelectionHtml()
  copytext = copytext.replace(/([^>\s&nbsp;]+)<\/?(p|span|div|br)( \/)?>/gi, '$1 ' + advert + '</$2>')
  copytext = copytext.replace(/<\/li>\s*<\/(ol|ul)>/gi, '</li><li>' + advert + '</li></$1>')
  copytext = copytext + '<br /><p>' + pagecopy + '</p>'
  var newdiv = $('<div>')
    .css({
      position: 'absolute',
      left: '-99999px'
    })
    .html(copytext)
    .appendTo('body')

  if (document.body.createTextRange) {
    var textRange = document.body.createTextRange()
    textRange.moveToElementText(newdiv.get(0))
    textRange.select()
  } else {
    var selection = window.getSelection()
    selection.selectAllChildren(newdiv.get(0))
  }

  window.requestAnimationFrame(function() {
    newdiv.remove()
  })
}

$(document).bind('cut copy', copySelection)
$('input, select, textarea, a, #foot, .kontaktTable, .workCols, label').bind('cut copy', function(e) {
  if (e.stopPropagation) e.stopPropagation()
}) // $('.aplikacje-webowe-svg .triangle').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(e) {
//     e.target.classList.add("finished");
// });
//ocenianie podstron z ofertą dla poszczególnych miast

$('.ratings__stars .star').click(function(e) {
  e.preventDefault()
  var ratingPreloader = new preloaderControl('.ratings__wrap')
  ratingPreloader.showPreloader()
  var pathPre = window.location.href.match(/oferta/) ? '../' : ''
  var request = $.ajax({
    method: 'POST',
    cache: false,
    url: pathPre + 'php/rating.php',
    data: {
      city: $(this).data('city'),
      vote: $(this).data('vote')
    }
  })
  request.done(function(data) {
    data = JSON.parse(data)

    if (data.error) {
      ratingPreloader.removePreloader()
      return
    }

    if (data.success == 1) {
      $('.rating_numbers__average').html(data.numbers.average)
      $('.rating_numbers__total').html(data.numbers.total)
      var lastFullstar = Math.floor(data.numbers.average)
      var halfStar = parseInt((data.numbers.average - lastFullstar) * 100)

      for (var i = 0; i < 6; i++) {
        if (i <= lastFullstar) {
          $('.ratings__stars .star:nth-child(' + i + ') .star__fullstar').css('width', '100%')
        } else if (i == lastFullstar + 1) {
          $('.ratings__stars .star:nth-child(' + i + ') .star__fullstar').css('width', halfStar + '%')
        } else {
          $('.ratings__stars .star:nth-child(' + i + ') .star__fullstar').css('width', '0%')
        }
      }
    } else if (data.success == 0) {
      $('.ratings__message').html('Nie udało się oddać głosu, być może głosowałeś już wcześniej?')
    }

    ratingPreloader.removePreloader()
    return
  })
}) // ocenianie artykułów na blogu

$('.content_rating .stars > a').click(function(e) {
  e.preventDefault()
  var thisElement = $(this)
  var formElement = thisElement.parents('form')
  formElement.find('input[name="user_rating"]').val(thisElement.data('rating'))
  var formValues = new FormData(formElement[0])
  var request = $.ajax({
    method: 'POST',
    cache: false,
    url: formElement.attr('action'),
    data: formValues,
    processData: false,
    contentType: false
  })
  request.done(function(response) {
    if (response.data[0] === true) {
      $('.ratings__message').html('Dziękujemy za Twój głos!')
    } else {
      $('.ratings__message').html('Nie udało się oddać głosu, być może głosowałeś już wcześniej?')
    }
  })
})
$('.showPriceform').click(function(e) {
  e.preventDefault()
  $('#wycenaLink').trigger('click')

  const setActive = e.target.dataset.setActive;
  const modal = document.querySelector('#wycenaModal');

  if(setActive) {
    modal.dataset.clicked = setActive;
  }
}) // animacja w aplikacjach webowych i mobilnych

if (ie) {
  $('.animation_container')
    .siblings('.mobile')
    .removeClass('mobile')
  $('.animation_container').remove()
}

if ($('.animation_container').length > 0) {
  var checkDistance = function checkDistance() {
    var windowheight = $(window).height()
    var windowDistance = $(window).scrollTop()
    var elementDistance = $('.animation_container').offset().top

    if (windowDistance + windowheight > elementDistance) {
      $('.animation_container').addClass('trigger_animation')
    }
  }

  checkDistance()
  $(window).scroll(function() {
    checkDistance()
  })
}

$('.animation_container img, .animation_container div').one(
  'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
  function() {
    $(this).removeClass('fade_in left_in right_in top_in rotate_in width_in')
  }
) //podstrona aplikacje mobilne

$('.gray_planet').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('gray_planet_animation')
})
$('.red_planet').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('red_planet_animation')
})
$('.marker').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('marker_animation')
})
$('.dots_circle').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('scale_me')
})
$('.plus').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('scale_me')
})
$('.percent').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('scale_me')
})
$('.dolar').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('flying_element')
})
$('.element').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('flying_element_reverse')
})
$('.gray_circle').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('flying_element')
})
$('.cart').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('cart_animation')
})
$('.gift').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('flying_element')
})
$('.play').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('flying_element_reverse')
})
$('.lines').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('flying_element')
}) //podstrona aplikacje webowe

$('.mechanic_wheel, .mechanic_wheel_2, .french_key').one(
  'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
  function() {
    $(this).addClass('slow_rotate')
  }
)
$('.red_circle, .blue_red_triangle').one(
  'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
  function() {
    $(this).addClass('flying_element_reverse')
  }
)
$('.question_mark').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('scale_me')
})
$('.red_circle_small_2, .red_circle_small, .blue_circle_small').one(
  'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
  function() {
    $(this).addClass('flying_element_2')
  }
)
$('.crosshair, .blue_triangle').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('flying_element')
})
$('.bulp').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $(this).addClass('marker_animation')
})
$('.aplikacje_webowe_bg').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  var animationPreloader = new preloaderControl('.animation_preloader')
  animationPreloader.showPreloader()
})
$('.web_apps_way').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
  $('.web_apps_way .path_element').addClass('web_apps_way_animation')
}) //tag manager dla usera który zescrolluje dalej nież do połowy PODSTRONY

var siteHeight = $('body').height()
var windowHeight = $(window).height()
var trigger = 1
$(window).scroll(function() {
  var scrollDistance = $(this).scrollTop()
  var distance = siteHeight / 2 + windowHeight / 2

  if (distance / 2 < scrollDistance && trigger == 1) {
    trigger = 0 //informacja dla google manager TAG

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'scroll',
      strona: $root
    })
  }
}) // Get page title

var pageTitle = $('title').text();
if ($('html').attr('lang')=='pl-PL') { // Change page title on blur
  $(window).blur(function() {
    $('title').text('Wróć do nas :)')
  }) // Change page title back on focus
  $(window).focus(function() {
    $('title').text(pageTitle)
  })
}
else if ($('html').attr('lang')=='en-GB') {
  $(window).blur(function() {
        $('title').text('Come back to us :)')
  }) // Change page title back on focus
  $(window).focus(function() {
        $('title').text(pageTitle)
  })
}

$('.kontaktForm .checkbox').click(function() {
  var input = $(this).find('input')

  if (input.is(':checked')) {
    $(this).removeClass('checked')
    input.prop('checked', false)
    input.checked = false
    input.change()
  } else {
    $(this).addClass('checked')
    input.prop('checked', true)
    input.checked = true
    input.change()
  }
})
/**** scale an image in a blogpost on a click ****/

if ($(window).width() > 1024) {
  $('.blog-single-post img').click(function(e) {
    e.stopPropagation()
    $(this).toggleClass('clicked')
  })
  $('.blog-single-post').click(function() {
    $(this)
      .find('img')
      .removeClass('clicked')
  })
} // //video HTML5 fix
// var video = document.querySelector(".case-video video");
// console.log(video);
// 	if (video !== null) {
// 		video.play();
// 		console.log("DONE!");
// 	}

var $iframe = $('#grzebieniskoVideo')
$iframe.hide()
var $videoContainer = $('.videoWrapper')
var src = 'https://www.youtube.com/embed/ILNuBUFlU1A'
$('.videoThumbnail').on('click', function(e) {
  $(this).hide()
  e.preventDefault()
  src = src + '?&autoplay=1' // src: the original URL for embedding

  $videoContainer.empty().append(
    $iframe.clone().attr({
      src: src
    })
  ) // $iframe: the original iframe for embedding

  $('#grzebieniskoVideo').show()
})
